export default __webpack_public_path__ + "static/media/qualidade1.74c29548.jpg";